import { isPrereleaseEnv, isProductionEnv } from 'utils/common';

export const STRIPE_PUBLIC_KEY = !(isProductionEnv() || isPrereleaseEnv()) ? 'pk_test_51MgtXaLWCWKPYTPjHlPhj8n9wXZ1a43RqravxqWcSVaRHcULwjYvP1i8Y1P6AUf6qboRoVTVBxtT31OzaLEoXu5S009KRfIY8t' : 'pk_live_51MgtXaLWCWKPYTPjUOrSfOAEWGvjkqQKbczP6x2QAIfAD67w1emhH9w0J4QRhOCAZ0j1owRJFZRJVPvPa68gYd4M00GlbUbLco';
